<template>
  <v-container fluid style="padding-left: 300px">
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <v-form class="mb-4" @submit.prevent="searchOrders">
          <v-card elevation="0" tile outlined>
            <v-card-text>
              <div>1. 検索対象サイトを選んでください</div>
              <v-layout row>
                <v-select
                  v-model="selectedSite"
                  :items="selectableDisplayNameSites"
                  item-text="name"
                  item-value="siteKey"
                  return-object
                  style="max-width: 150px"
                  class="ma-2"
                  clearable
                  label="対象サイト"
                />
              </v-layout>
              <v-divider />
              <div class="mt-3">2. 検索条件を入力してください</div>
              <v-layout row>
                <v-text-field
                  v-model="searchQuery.titleOrQueryCont"
                  label="キーワード"
                  style="max-width: 400px"
                  clearable
                  class="ma-2"
                />
                <v-text-field
                  v-model="searchQuery.postClassificationCont"
                  label="記事種別"
                  style="max-width: 400px"
                  clearable
                  class="ma-2"
                />
                <v-btn
                  color="primary"
                  dark
                  tile
                  outlined
                  class="ma-2"
                  type="submit"
                  :disabled="!selectedSite"
                  @click="searchOrders"
                  @submit.prevent="searchOrders"
                >
                  検索
                </v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-form>

        <v-row class="py-5">
          <v-col md="10" lg="5">
            <v-card>
              <v-card-subtitle> 本数 </v-card-subtitle>
              <v-card-text>
                <div class="text-center display-2">
                  {{ orders.length }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col md="10" lg="6">
            <v-card>
              <v-card-subtitle> 合計金額 </v-card-subtitle>
              <v-card-text>
                <div class="text-center display-2">
                  {{ totalSalesPrice() | jpyPriceNotation }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <order-table :orders="orders" @client-completion="clientCompletion" />
        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。 </v-chip>
          </template>
        </infinite-loading>

        <v-dialog v-model="displayResultMessages" scrollable width="500">
          <v-card>
            <v-card-title> クライアント校了結果 </v-card-title>
            <v-card-text>
              <v-alert
                v-if="successResultMessages().length !== 0"
                dense
                outlined
                type="success"
              >
                <li
                  v-for="result in successResultMessages()"
                  :key="result.id"
                  class="caption"
                >
                  発注ID:{{ result.id }} {{ result.message }}
                </li>
              </v-alert>
              <v-alert
                v-if="errorResultMessages().length !== 0"
                dense
                outlined
                type="error"
              >
                <li
                  v-for="result in errorResultMessages()"
                  :key="result.id"
                  class="caption"
                >
                  発注ID:{{ result.id }} {{ result.message }}
                </li>
              </v-alert>
            </v-card-text>

            <v-card-actions class="justify-end">
              <v-btn text @click="displayResultMessages = false">閉じる</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import Qs from 'qs'
import { mapGetters } from 'vuex'
import { deserialize } from 'deserialize-json-api'
import OrderTable from '@/components/commons/orders/MasterClientTable'
import format_utils from '@/mixins/format_utils'
import headUtilsMixin from '@/mixins/head_utils'
import { cloneDeep } from 'lodash'

export default {
  mixins: [format_utils, headUtilsMixin],
  components: {
    OrderTable,
    InfiniteLoading
  },
  data: () => {
    return {
      pageTitle: '発注一覧',
      orders: [],
      page: 1,
      searchQuery: {
        titleOrQueryCont: null,
        postClassificationCont: null
      },
      infiniteId: +new Date(),
      selectedSite: null,
      resultMessages: [],
      displayResultMessages: false
    }
  },
  computed: {
    ...mapGetters('UserAuthStore', ['selectableSites']),
    selectableDisplayNameSites () {
      let tmpArr = cloneDeep(this.selectableSites)
      tmpArr.forEach(site => {
        if (site.displayName) {
          site.name = site.displayName
        }
      })
      return tmpArr
    }
  },
  watch: {
    selectedSite () {
      this.searchOrders()
    }
  },
  methods: {
    searchOrders () {
      this.orders = []
      this.infiniteId++
      this.page = 1
    },
    infiniteHandler ($state) {
      if (!this.selectedSite) {
        $state.complete()
        return true
      }

      axios
        .get('/api/master/orders', {
          params: {
            page: this.page,
            q: this.searchQuery,
            site_key: this.selectedSiteKey()
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedOrders = deserialize(data).data
          if (fetchedOrders.length > 0) {
            this.page++
            this.orders = this.orders.concat(fetchedOrders)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    selectedSiteKey () {
      return this.selectedSite.siteKey
    },
    clientCompletion (orderIds) {
      this.$store.dispatch('LoaderStore/displayLoader')

      const params = {
        siteKey: this.selectedSiteKey(),
        order: { ids: orderIds }
      }
      axios.patch('/api/master/orders/client_completion', params).then(
        ({ data }) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.searchOrders()
          this.resultMessages = data
          this.displayResultMessages = true
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: error.response.status,
            message: error.response.data.message.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    successResultMessages () {
      return this.resultMessages.filter((result) => result.successful)
    },
    errorResultMessages () {
      return this.resultMessages.filter((result) => !result.successful)
    },
    totalSalesPrice () {
      return this.orders.reduce((sum, order) => sum + order.salesPrice, 0) || '0'
    }
  }
}
</script>
